import Image from "next/image";

const integrations = [
  { name: "Codex", src: "/brands/codex.png" },
  { name: "Claude", src: "/brands/claude.jpg" },
  { name: "ChatGPT", src: "/brands/openai.svg" },
];

export function IntegrationsBand() {
  return (
    <section className="integrations-band" aria-labelledby="integrations-heading">
      <p id="integrations-heading">Integrates with</p>
      <div className="integration-icons">
        {integrations.map((integration) => (
          <Image
            key={integration.name}
            src={integration.src}
            alt={integration.name}
            width={48}
            height={48}
          />
        ))}
      </div>
    </section>
  );
}
